/**
 * Loops through all our sticky navs and initiates them
 * 
 * @export
 * @class StickyNavs
 */
import { forEach } from '../../helpers/utilities';

import { StickyNav } from './sticky-nav';

export class StickyNavs {

    constructor() {
        const navs = document.querySelectorAll('[data-sticky-nav]');

        forEach(navs, ({}, nav: Element) => {
            const identifier = <string>nav.getAttribute('data-sticky-nav');
            if(identifier) new StickyNav(nav, identifier);
        });
    }
}
